import { render } from "./DistributionChartModal.vue?vue&type=template&id=067da906&ts=true"
import script from "./DistributionChartModal.vue?vue&type=script&lang=ts"
export * from "./DistributionChartModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__